import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon, AwardIcon } from 'lucide-react';
import { createPortal } from 'react-dom';
const COURSES = [{
  title: 'A-Kurs White Aesthetics',
  points: 15,
  slug: 'white-aesthetics',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/whiteaestetics.jpg'
}, {
  title: 'B-Kurs Red Aesthetics',
  points: 16,
  slug: 'red-aesthetics',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kursweichgewebe.jpg'
}, {
  title: 'C-Kurs Funktion',
  points: 16,
  slug: 'funktionsanalyse-therapie',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kursfunktionellezahnmedizin.jpg'
}, {
  title: 'D-Kurs Champions League',
  points: 15,
  slug: 'champions-league',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kurspraxismanagement.jpeg'
}, {
  title: 'Female Boss',
  points: 7,
  slug: 'female-boss',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kursfemaleboss.jpg'
}, {
  title: 'Alignertherapie',
  points: 16,
  slug: 'alignertherapie',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/kursalignertherapie.jpg'
}];
const SPEAKERS = [{
  name: 'Dr. Thomas Schwenk',
  title: 'Prothetik & Parodontologie',
  slug: 'dr-thomas-schwenk',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/schwenk.jpg'
}, {
  name: 'Dr. Marcus Striegel',
  title: 'Ästhetische Zahnheilkunde',
  slug: 'dr-marcus-striegel',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/striegel.jpg'
}, {
  name: 'Dr. Johanna Herzog',
  title: 'Sportzahnmedizin',
  slug: 'dr-johanna-herzog',
  img: 'https://cdn.rawproductionsgmbh.de/2n/home/herzog.jpg'
}];
function MobileMenu({
  isOpen,
  isScrolled,
  onClose
}: {
  isOpen: boolean;
  isScrolled: boolean;
  onClose: () => void;
}) {
  if (!isOpen) return null;
  const headerHeight = isScrolled ? 64 : 96;
  return createPortal(<div className="lg:hidden" style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999
  }} data-id="element-303">
      {/* Backdrop - starts below header */}
      <div onClick={onClose} className="animate-fadeIn" style={{
      position: 'absolute',
      top: headerHeight,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(4px)'
    }} data-id="element-304" />

      {/* Slide-in Panel - starts below header, goes to bottom */}
      <div className="animate-slideInRight" onClick={e => e.stopPropagation()} style={{
      position: 'fixed',
      top: headerHeight,
      right: 0,
      bottom: 0,
      width: '80vw',
      maxWidth: 384,
      backgroundColor: '#ffffff',
      boxShadow: '-10px 0 40px rgba(0,0,0,0.2)',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'hidden'
    }} data-id="element-305">
        {/* Scrollable content area */}
        <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '24px',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-306">
          <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px'
        }} data-id="element-307">
            {/* Navigation Links */}
            <div data-id="element-308">
              <h3 className="text-xs font-extrabold text-[#748282] uppercase tracking-wider mb-4" data-id="element-309">
                Navigation
              </h3>
              <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }} data-id="element-310">
                <Link to="/" className="block text-xl font-bold text-slate-700 hover:text-[#3b7780]" onClick={onClose} data-id="element-311">
                  Startseite
                </Link>
                <Link to="/termine" className="block text-xl font-bold text-slate-700 hover:text-[#3b7780]" onClick={onClose} data-id="element-312">
                  Termine
                </Link>
                <Link to="/mediathek" className="block text-xl font-bold text-slate-700 hover:text-[#3b7780]" onClick={onClose} data-id="element-313">
                  Mediathek
                </Link>
                <Link to="/kontakt" className="block text-xl font-bold text-slate-700 hover:text-[#3b7780]" onClick={onClose} data-id="element-314">
                  Kontakt
                </Link>
              </div>
            </div>

            {/* Kurse */}
            <div style={{
            borderTop: '1px solid #f1f5f9',
            paddingTop: '24px'
          }} data-id="element-315">
              <h3 className="text-xs font-extrabold text-[#748282] uppercase tracking-wider mb-4" data-id="element-316">
                Kurse
              </h3>
              <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }} data-id="element-317">
                {COURSES.map(course => <Link key={course.slug} to={`/kurse/${course.slug}`} className="block text-base font-semibold text-slate-500 hover:text-[#3b7780]" onClick={onClose} data-id="element-318">
                    {course.title}
                  </Link>)}
              </div>
            </div>

            {/* Referenten */}
            <div style={{
            borderTop: '1px solid #f1f5f9',
            paddingTop: '24px'
          }} data-id="element-319">
              <h3 className="text-xs font-extrabold text-[#748282] uppercase tracking-wider mb-4" data-id="element-320">
                Referenten
              </h3>
              <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }} data-id="element-321">
                {SPEAKERS.map(speaker => <Link key={speaker.slug} to={`/referenten/${speaker.slug}`} className="block text-base font-semibold text-slate-500 hover:text-[#3b7780]" onClick={onClose} data-id="element-322">
                    {speaker.name}
                  </Link>)}
              </div>
            </div>
          </div>
        </div>

        {/* Fixed bottom CTA */}
        <div style={{
        padding: '24px',
        borderTop: '1px solid #f1f5f9',
        backgroundColor: '#f8fafc',
        flexShrink: 0
      }} data-id="element-323">
          <Link to="/kontakt" className="block w-full text-center bg-[#3b7780] hover:bg-[#2d5f66] text-white px-6 py-4 rounded-md font-bold transition-colors shadow-md" onClick={onClose} data-id="element-324">
            Jetzt buchen
          </Link>
        </div>
      </div>
    </div>, document.body);
}
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isReferentenDropdownOpen, setIsReferentenDropdownOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false);
    setIsReferentenDropdownOpen(false);
  }, [location.pathname]);
  // Lock body scroll when menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md transition-all duration-300 ${isScrolled ? 'h-16 shadow-lg border-b border-slate-200' : 'h-24 border-b border-transparent'}`} data-id="element-325">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full" data-id="element-326">
          <div className="flex justify-between items-center h-full" data-id="element-327">
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center" data-id="element-328">
              <Link to="/" className="flex items-center" data-id="element-329">
                <img src="https://cdn.rawproductionsgmbh.de/2n/home/sitelogo.png" alt="2N Zahnärztliche Fortbildungen Logo" className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-10' : 'h-14'}`} data-id="element-330" />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-8 items-center h-full" data-id="element-331">
              {/* Kurse Dropdown */}
              <div className="relative h-full flex items-center group" onMouseEnter={() => setIsDropdownOpen(true)} onMouseLeave={() => setIsDropdownOpen(false)} data-id="element-332">
                <button className="flex items-center gap-1 text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-333">
                  Kurse{' '}
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} data-id="element-334" />
                </button>

                {/* Dropdown Panel */}
                <div className={`absolute top-full left-1/2 -translate-x-1/2 w-[600px] bg-white rounded-xl shadow-2xl border border-slate-100 transition-all duration-200 origin-top ${isDropdownOpen ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-4 invisible'}`} data-id="element-335">
                  <div className="p-6 grid grid-cols-2 gap-4" data-id="element-336">
                    {COURSES.map(course => <Link key={course.slug} to={`/kurse/${course.slug}`} className="flex items-center gap-4 p-3 rounded-lg hover:bg-slate-50 transition-colors group/item" data-id="element-337">
                        <img src={course.img} alt={course.title} className="w-12 h-12 rounded-lg object-cover shadow-sm" data-id="element-338" />
                        <div data-id="element-339">
                          <h4 className="font-bold text-slate-700 group-hover/item:text-[#3b7780] transition-colors text-sm" data-id="element-340">
                            {course.title}
                          </h4>
                          <div className="flex items-center gap-1 mt-1" data-id="element-341">
                            <AwardIcon className="w-3 h-3 text-[#59d0d4]" data-id="element-342" />
                            <span className="text-xs font-semibold text-[#748282]" data-id="element-343">
                              {course.points} Punkte
                            </span>
                          </div>
                        </div>
                      </Link>)}
                  </div>
                  <div className="bg-slate-50 p-4 rounded-b-xl border-t border-slate-100 text-center" data-id="element-344">
                    <Link to="/#kurse" className="text-sm font-bold text-[#3b7780] hover:text-[#2d5f66]" data-id="element-345">
                      Alle Kurse ansehen &rarr;
                    </Link>
                  </div>
                </div>
              </div>

              {/* Referenten Dropdown */}
              <div className="relative h-full flex items-center group" onMouseEnter={() => setIsReferentenDropdownOpen(true)} onMouseLeave={() => setIsReferentenDropdownOpen(false)} data-id="element-346">
                <button className="flex items-center gap-1 text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-347">
                  Referenten{' '}
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${isReferentenDropdownOpen ? 'rotate-180' : ''}`} data-id="element-348" />
                </button>

                {/* Dropdown Panel */}
                <div className={`absolute top-full left-1/2 -translate-x-1/2 w-[350px] bg-white rounded-xl shadow-2xl border border-slate-100 transition-all duration-200 origin-top ${isReferentenDropdownOpen ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-4 invisible'}`} data-id="element-349">
                  <div className="p-4 flex flex-col gap-2" data-id="element-350">
                    {SPEAKERS.map(speaker => <Link key={speaker.slug} to={`/referenten/${speaker.slug}`} className="flex items-center gap-4 p-3 rounded-lg hover:bg-slate-50 transition-colors group/item" data-id="element-351">
                        <img src={speaker.img} alt={speaker.name} className="w-10 h-10 rounded-full object-cover shadow-sm border border-slate-200" data-id="element-352" />
                        <div data-id="element-353">
                          <h4 className="font-bold text-slate-700 group-hover/item:text-[#3b7780] transition-colors text-sm" data-id="element-354">
                            {speaker.name}
                          </h4>
                          <p className="text-xs font-semibold text-[#748282] mt-0.5" data-id="element-355">
                            {speaker.title}
                          </p>
                        </div>
                      </Link>)}
                  </div>
                  <div className="bg-slate-50 p-4 rounded-b-xl border-t border-slate-100 text-center" data-id="element-356">
                    <Link to="/#referenten" className="text-sm font-bold text-[#3b7780] hover:text-[#2d5f66]" data-id="element-357">
                      Alle Referenten ansehen &rarr;
                    </Link>
                  </div>
                </div>
              </div>

              <Link to="/termine" className="text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-358">
                Termine
              </Link>
              <Link to="/mediathek" className="text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-359">
                Mediathek
              </Link>
              <Link to="/kontakt" className="text-slate-700 hover:text-[#3b7780] font-bold transition-colors" data-id="element-360">
                Kontakt
              </Link>

              <Link to="/kontakt" className="bg-[#3b7780] hover:bg-[#2d5f66] text-white px-6 py-2.5 rounded-md font-bold transition-all hover:scale-105 hover:shadow-lg active:scale-95" data-id="element-361">
                Jetzt buchen
              </Link>
            </nav>

            {/* Mobile menu button */}
            <div className="lg:hidden flex items-center" data-id="element-362">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-700 hover:text-[#3b7780] focus:outline-none p-2" data-id="element-363">
                {isMobileMenuOpen ? <XIcon className="h-7 w-7" data-id="element-364" /> : <MenuIcon className="h-7 w-7" data-id="element-365" />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile menu rendered via Portal - completely outside header */}
      <MobileMenu isOpen={isMobileMenuOpen} isScrolled={isScrolled} onClose={() => setIsMobileMenuOpen(false)} data-id="element-366" />
    </>;
}